import { render, staticRenderFns } from "./ShippingFees.vue?vue&type=template&id=f707dd9a"
import script from "./ShippingFees.vue?vue&type=script&lang=js"
export * from "./ShippingFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports